module.exports = __webpack_public_path__ + "img/营口博爱医药连锁有限公司坐落于辽宁省营口市，是一家集零售、批发与电商于一体的综合性医药企业，覆盖线下连锁+线上B2C电商+批发.24ee08e6.png";